import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ellipsis",
  "use": "icon-ellipsis-usage",
  "viewBox": "0 0 3 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 3 4\" fill=\"none\" id=\"icon-ellipsis\">\n  <circle cx=\"1.5\" cy=\"2\" r=\"1.5\" fill=\"#A5ABB0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol